module.exports = __webpack_public_path__ + "static/media/Dysmate2_compressed.49613438.pdf";